const DOCUMENT = 'ASSIGN_TALENT_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_MY_TEAM: DOCUMENT + 'LOAD_MY_TEAM',
  LOAD_MY_TEAM_SUCCESS: DOCUMENT + 'LOAD_MY_TEAM_SUCCESS',
  LOAD_AFTER_ACTION: DOCUMENT + 'LOAD_AFTER_ACTION',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadMyTeamData: data => ({
    type: actions.LOAD_MY_TEAM,
    payload: data,
  }),

  loadMyTeamDataSuccess: data => ({
    type: actions.LOAD_MY_TEAM_SUCCESS,
    payload: data,
  }),

  loadAfterAction: data => ({
    type: actions.LOAD_AFTER_ACTION,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  assignWorker: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),
};

export default actions;
